import { useQuery } from '@tanstack/react-query'
import { getEntryById } from '../lib/search-service'
import { useOffline } from '@/components/offline-context'

export function useEntry(id?: number) {
  const { isOfflineEnabled, isReady, isQueryEnabled } = useOffline()
  const isOffline = isOfflineEnabled && isReady

  return useQuery({
    // Remove isOffline from query key to prevent cache invalidation
    // The queryFn will handle offline/online mode internally
    queryKey: ['entry', id],
    queryFn: async () => {
      if (!id) return null
      return await getEntryById(id, isOffline)
    },
    enabled: isQueryEnabled(!!id),
    staleTime: 1000 * 60 * 60, // Cache detail views for 1 hour
    placeholderData: (previousData) => previousData, // Keep previous data visible during transitions
    gcTime: 1000 * 60 * 60 * 2, // Keep in cache for 2 hours
    refetchOnMount: false, // Don't refetch when component mounts if data is fresh
    refetchOnWindowFocus: false, // Don't refetch on window focus
    refetchOnReconnect: false // Don't refetch on reconnect
  })
}
